<template>
  <div>
    <Title :pages="[{ icon: 'box', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12 elevation-0" style="background: white">
              <div class="row pt-5">
                <div class="col-md-3 pt-0">
                  <v-menu
                    ref="desde_selected"
                    v-model="desde_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="desde_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    clearable
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field 
                        v-model="desde_selected" 
                        label="Desde" 
                        prepend-icon="mdi-calendar" 
                        readonly 
                        v-bind="attrs" 
                        v-on="on" 
                        class="pt-0 mt-0"
                        clearable
                        @click:clear="desde_selected = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_selected_open = false"> Cancelar </v-btn>
                      <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-menu
                    ref="hasta_selected"
                    v-model="hasta_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="hasta_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    clearable
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field 
                        v-model="hasta_selected" 
                        label="Hasta" 
                        prepend-icon="mdi-calendar" 
                        readonly 
                        v-bind="attrs" 
                        v-on="on" 
                        class="pt-0 mt-0"
                        clearable
                        @click:clear="hasta_selected = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_selected_open = false"> Cancelar </v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox
                    v-model="warehouse_selected"
                    autocomplete="off"
                    item-text="name"
                    item-value="id"
                    :items="warehouses"
                    label="Almacén"
                    class="pt-0 mt-0"
                    clearable
                    @change="$store.commit('setFilterMovementsStock', { warehouse_selected: warehouse_selected })"
                    @clear="$store.commit('setFilterMovementsStock', { warehouse_selected: null })"
                  ></v-combobox>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox
                    v-model="product_selected"
                    autocomplete="off"
                    item-text="label"
                    item-value="id"
                    :items="products"
                    label="Producto"
                    class="pt-0 mt-0"
                    clearable
                    @change="$store.commit('setFilterMovementsStock', { product_selected: product_selected })"
                    @clear="$store.commit('setFilterMovementsStock', { product_selected: null })"
                  ></v-combobox>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox
                    v-model="document_type_selected"
                    autocomplete="off"
                    item-text="name"
                    item-value="id"
                    :items="document_types"
                    label="Tipo de Documento"
                    class="pt-0 mt-0"
                    clearable
                    @change="$store.commit('setFilterMovementsStock', { document_type_selected: document_type_selected })"
                    @clear="$store.commit('setFilterMovementsStock', { document_type_selected: null })"
                  ></v-combobox>
                </div>

                <div class="col pt-0" :style="{ display: 'flex', justifyContent: 'flex-end' }">
                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <v-btn 
            color="blue-grey mr-2 mt-3" 
            small 
            dark 
            @click="exportListado" 
            :loading="dialog_export"
          > 
            Exportar
            <font-awesome-icon class="ml-2" icon="download" />
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field 
            v-model="search" 
            append-icon="search" 
            label="Buscar" 
            single-line 
            hide-details 
            @input="updateSearch"
          ></v-text-field>
        </v-card-title>

        <v-data-table 
          :items="list" 
          :search="search" 
          :loading="loading" 
          loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }" 
          @pagination="updatePagination" 
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }"
          :page="update_page"
          @update:page="updatePage"
          :headers="headers"
          hide-default-header
        >
          <!-- Headers personalizados con agrupación -->
          <template v-slot:header>
            <thead>
              <tr>
                <!-- Headers normales -->
                <th class="text-left" rowspan="2">Número</th>
                <th class="text-left" rowspan="2">Fecha</th>
                <th class="text-left" rowspan="2">Almacén</th>
                <th class="text-left" rowspan="2">Producto</th>
                <th class="text-left" rowspan="2">Presentacion</th>
                
                <!-- Grupo MOVIMIENTOS -->
                <th class="text-center group-header movements-group" colspan="2" style="background-color: #e3f2fd; border-right: 2px solid #1976d2;">MOVIMIENTOS</th>
                
                <!-- Grupo STOCK -->
                <th class="text-center group-header stock-group" colspan="3" style="background-color: #f3e5f5; border-right: 2px solid #7b1fa2;">STOCK</th>
              </tr>
              
              <!-- Segunda fila: Sub-headers -->
              <tr class="sub-header-row">
                <!-- Sub-headers MOVIMIENTOS -->
                <th class="text-center sub-header movements-sub" style="background-color: #e3f2fd;">Ingresos</th>
                <th class="text-center sub-header movements-sub" style="background-color: #e3f2fd; border-right: 2px solid #1976d2;">Egresos</th>
                
                <!-- Sub-headers STOCK -->
                <th class="text-center sub-header stock-sub" style="background-color: #f3e5f5;">Disponible</th>
                <th class="text-center sub-header stock-sub" style="background-color: #f3e5f5;">Reservado</th>
                <th class="text-center sub-header stock-sub" style="background-color: #f3e5f5; border-right: 2px solid #7b1fa2;">Futuro</th>
              </tr>
            </thead>
          </template>

          <template v-slot:item="props">
            <tr>
              <td>
                {{ (pagination.page - 1) * pagination.itemsPerPage + props.index + 1 }}
              </td>
              <td>{{ props.item.fecha }}</td>
              <td>{{ props.item.warehouse ? props.item.warehouse.name : '-' }}</td>
              <td>
                <div>

                  {{ props.item.product_presentation ? props.item.product_presentation.product_name : '-' }}
                </div>
                  <span class="text-caption" v-if="props.item.product_presentation && props.item.product_presentation.product_sku">SKU: {{ props.item.product_presentation.product_sku }}</span>
            </td>
            <td> {{ props.item.product_presentation ? props.item.product_presentation.presentation_type.name : '-' }}</td>
              
              <!-- Grupo MOVIMIENTOS -->
              <td class="text-center movements-data" style="background-color: #f5faff;">
                <span style="color: #2e7d32;">{{ formatUtils.formatNumber(props.item.ingresos) }}</span>
              </td>
              <td class="text-center movements-data" style="background-color: #f5faff;">
                <span style="color: #c62828;">{{ formatUtils.formatNumber(props.item.egresos) }}</span>
              </td>
              
              <!-- Grupo STOCK -->
              <td class="text-center stock-data" style="background-color: #faf5fc;">
                <span class="font-weight-bold">{{ formatUtils.formatNumber(props.item.stock_disponible) }}</span>
              </td>
              <td class="text-center stock-data" style="background-color: #faf5fc;">
                {{ formatUtils.formatNumber(props.item.stock_reservado) }}
              </td>
              <td class="text-center stock-data" style="background-color: #faf5fc;">
                {{ formatUtils.formatNumber(props.item.stock_futuro) }}
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Búsqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { formatUtils } from "@/libs/utils/formatUtils";
import { generalService } from "@/libs/ws/generalService";
import { inventoryOperationService } from "@/libs/ws/inventoryOperationService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";

export default {
  components: { Title },
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      Constant: Constant,
      formatUtils: formatUtils,
      page_title: "Movimientos de Stock",
      headers: [
        { text: "Número", value: "number" },
        { text: "Fecha", value: "fecha" },
        {
          text: "Almacén",
          align: "left",
          sortable: true,
          value: "warehouse.name",
        },
        {
          text: "Producto",
          align: "left",
          sortable: true,
          value: "product_presentation.product_name",
        },
        {
          text: "Presentación",
          align: "left",
          sortable: true,
          value: "product_presentation.name",
        },
        { 
          text: "Ingresos", 
          value: "ingresos", 
          align: "center",
          sortable: true 
        },
        { 
          text: "Egresos", 
          value: "egresos", 
          align: "center",
          sortable: true 
        },
        { 
          text: "Disponible", 
          value: "stock_disponible", 
          align: "center",
          sortable: true 
        },
        { 
          text: "Reservado", 
          value: "stock_reservado", 
          align: "center",
          sortable: true 
        },
        { 
          text: "Futuro", 
          value: "stock_futuro", 
          align: "center",
          sortable: true 
        },
      ],
      warehouses: [],
      products: [],
      document_types: [],
      list: [],
      desde_selected: this.$store.state.movements_stock?.filter?.desde_selected,
      hasta_selected: this.$store.state.movements_stock?.filter?.hasta_selected,
      warehouse_selected: this.$store.state.movements_stock?.filter?.warehouse_selected || null,
      product_selected: this.$store.state.movements_stock?.filter?.product_selected || null,
      document_type_selected: this.$store.state.movements_stock?.filter?.document_type_selected || null,
      desde_selected_open: false,
      hasta_selected_open: false,
      search: this.$store.state.movements_stock?.filter?.search || "",
      update_page: 1,
      dialog_export: false,
    };
  },
  mounted() {
    this.loadWarehouses();
    this.loadProducts();
    this.loadDocumentTypes();
    this.loadList();
  },
  methods: {
    loadWarehouses() {
      generalService.setSection(Constant.SECTION_WAREHOUSES);
      generalService
        .filter()
        .then((response) => {
          this.warehouses = response.result;
        })
        .catch((e) => {
          console.log("warehouses.filter error");
          console.log(e);
        });
    },
    loadProducts() {
      generalService.setSection(Constant.SECTION_PRODUCTS);
      generalService
        .filter()
        .then((response) => {
          this.products = response.result;
        })
        .catch((e) => {
          console.log("products.filter error");
          console.log(e);
        });
    },
    loadDocumentTypes() {
      inventoryOperationService
        .getAllDocumentTypes()
        .then((response) => {
          if (response.status) {
            this.document_types = response.result;
          }
        })
        .catch((e) => {
          console.log("document_types.filter error");
          console.log(e);
        });
    },
    updateSearch(value) {
      this.search = value;
      if (this.$store.state.movements_stock) {
        this.$store.commit('setFilterMovementsStock', { search: value });
      }
    },
    updatePage(page) {
      if (this.$store.state.movements_stock) {
        this.$store.commit('setCurrentPageMovementsStock', page);
      }
      this.update_page = page;
    },
    loadList() {
      this.loading = true;
      const param = this.getFilterParams();
      
      console.log("=== MOVEMENTS STOCK FRONTEND DEBUG ===");
      console.log("Parametros enviados:", param);

      generalService.setSection(Constant.SECTION_REPORT_STOCK_MOVEMENTS);
      generalService
        .query(param)
        .then((response) => {
          console.log("Respuesta recibida:", response);
          console.log("Total items:", response.result.length);
          if(response.result.length > 0){
            console.log("Primer item:", response.result[0]);
          }
          
          if (this.$store.state.movements_stock?.pagination?.page > 1) {
            this.update_page = this.$store.state.movements_stock.pagination.page;
          }

          this.list = response.result;
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("movements_stock.query error");
          console.log(e);
          this.loading = false;
        });
    },
    getFilterParams() {
      const param = {
        from: this.desde_selected,
        to: this.hasta_selected,
        warehouse: this.warehouse_selected != null ? { id: this.warehouse_selected.id } : null,
        product: this.product_selected != null ? { id: this.product_selected.id } : null,
        document_type: this.document_type_selected != null ? { id: this.document_type_selected.id } : null,
      };
      return param;
    },
    filter() {
      this.loadList();
    },
    exportListado() {
      this.dialog_export = true;
      const params = this.getFilterParams();
      params.export = true;
      
      this.exportExcel(
        Constant.SECTION_REPORT_STOCK_MOVEMENTS,
        params,
        "Movimientos-Stock.xlsx"
      );
      
      this.dialog_export = false;
    },
  },
};
</script>
